<template>
  <div :class="['content', programStyle]">
    <div class="title-container">
      <div class="title">Level 2 Charging Equipment</div>
    </div>
    <div v-if="mostRecentStatus && mostRecentStatus.result && mostRecentStatus.reason" class="review-container">
      <div
        :class="[
          'result-container',
          mostRecentStatus.result === 'Declined' || mostRecentStatus.result === 'Expired' ? 'red' : 'green',
        ]"
      >
        {{ mostRecentStatus.result }}
      </div>
      <div class="reason">{{ $t('reason', [mostRecentStatus.reason]) }}</div>
    </div>
    <div class="form-container">
      <div class="item-container" v-for="(appeal, index) in appeals" :key="appeal.dialId">
        <div class="dial-info">
          <div class="left-container flex-row">
            <div v-if="index === 0" :class="['circle', appeal.dialColor]">
              <div class="inner" v-if="appeal.dialResultText">
                {{ appeal.dialResultText }}
              </div>
            </div>
          </div>
          <div class="right-container flex-column">
            <div v-if="index === 0" class="title-small">* PROOF OF CHARGING EQUIPMENT INSTALLATION AND ACTIVATION</div>
            <div class="subtitle">{{ appeal.dialTitle }}</div>
          </div>
        </div>
        <div class="upload-container">
          <Upload
            :class="[validationCheck && !uploadsValidation ? 'uploads-required' : '']"
            v-if="!appeal.uploads"
            :appeal="appeal"
            v-on:sendurl="getUrl"
            @removeUpload="removeUpload"
          />
          <div v-if="validationCheck && !uploadsValidation" class="helper-text_error">
            <h4>
              You must upload photos of charge equipment and screenshots of charge point management software before
              continuing.
            </h4>
          </div>
          <div v-if="appeal.uploads">
            <h4 class="title">{{ $t('supporting-documents-0') }}</h4>
            <div class="support-docs" v-for="upload in appeal.uploads" :key="upload.key">
              <span v-if="upload.dialId === appeal.dialId">{{ upload.originalFilename }}</span>
              <a v-if="upload.dialId === appeal.dialId" class="relative" target="_blank" :href="upload.url">
                <img class="download-icon" src="@/assets/img/download-arrow.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container flex-column">
        <div class="form-details flex-column">
          <div class="title">Details</div>
          <div class="row-1 flex-row">
            <ul>
              <li class="input-label vendor-name"><label for="custom-input">* INSTALLER/VALIDATOR VENDOR:</label></li>
              <li class="custom-input xl flex-row" :class="[validationCheck && !formDetails.vendor ? 'required' : '']">
                <input
                  :class="[viewForm ? 'disabled' : '']"
                  required
                  v-model="formDetails.vendor"
                  :placeholder="'Enter name'"
                />
                <span class="custom-input-buttons flex-row" v-if="!viewForm">
                  <span class="edit-button" @click="formDetails.vendor = null">{{ $t('clear') }}</span>
                </span>
              </li>
            </ul>
          </div>
          <div class="row-2">
            <div class="row-title-container flex-row">
              <h3 class="collapsible-row-title">L2 CONNECTORS</h3>
            </div>
            <div id="active-l2-chargers">
              <div class="input-fields flex-row">
                <ul>
                  <li class="input-label required-level-two"><label for="custom-input">REQUIRED</label></li>
                  <li class="custom-input md flex-row">
                    <input class="disabled" v-model="formDetails.requiredLevelTwo" />
                  </li>
                </ul>
                <ul>
                  <li class="input-label unidentified-connectors">
                    <label for="custom-input">UNIDENTIFIED CONNECTORS</label>
                  </li>
                  <li
                    class="custom-input md flex-row"
                    :class="[validationCheck && lTwoConnectorsTotal > 0 ? 'required' : '']"
                  >
                    <input class="disabled" v-model="lTwoConnectorsTotal" />
                  </li>
                </ul>
                <ul>
                  <li class="input-label connector-type"><label for="custom-input">COMPLIANT</label></li>
                  <li class="input-label"><label for="custom-input">INSTALLED/ACTIVE</label></li>
                  <li
                    class="custom-input sm flex-row"
                    :class="[
                      validationCheck && (compliantInstalled === 0 || lTwoConnectorsTotal > 0) ? 'required' : '',
                    ]"
                  >
                    <input class="disabled" v-model="compliantInstalled" />
                  </li>
                  <li class="input-label"><label for="custom-input">ON ORDER</label></li>
                  <li
                    class="custom-input sm flex-row"
                    :class="[validationCheck && (compliantOnOrder === 0 || lTwoConnectorsTotal > 0) ? 'required' : '']"
                  >
                    <input class="disabled" v-model="compliantOnOrder" />
                  </li>
                </ul>
                <ul>
                  <li class="input-label connector-type"><label for="custom-input">NON-COMPLIANT</label></li>
                  <li class="input-label"><label for="custom-input">INSTALLED/ACTIVE</label></li>
                  <li class="custom-input sm flex-row">
                    <input class="disabled" v-model="nonCompliantInstalled" />
                  </li>
                  <li class="input-label"><label for="custom-input">ON ORDER</label></li>
                  <li class="custom-input sm flex-row">
                    <input class="disabled" v-model="nonCompliantOnOrder" />
                  </li>
                </ul>
              </div>
              <div class="requirements flex-column">
                <span>L2 Compliant Connector Requirements: >9.6kw CDJR; >11.5kw Alfa.</span>
                <!-- <span :class="[validationCheck && lTwoConnectorsTotal !== 0 ? 'helper-text_error' : '']"
                  >All Active Compliant connectors must have their brand/model identified below.</span
                >
                <span :class="[validationCheck && lTwoConnectorsTotal !== 0 ? 'helper-text_error' : '']"
                  >For example: if you have 3 Active Compliant connectors, the total quantity of all connector
                  brand/models you identify below must be 3.</span
                > -->
                <span class="helper-text_error" v-if="validationCheck && lTwoConnectorsTotal > 0"
                  >Your Installed/Active Compliant and On order/Not yet installed Compliant connectors are less than
                  your Required input. If this is correct, you may submit this form again and select “Continue”.</span
                >
              </div>
              <h4 class="equipment-type">INSTALLED/ACTIVE CONNECTORS</h4>
              <div class="standard-charger">
                <h4 class="charger-title">Compliant Connectors</h4>
                <div
                  class="input-fields flex-row"
                  v-for="(charger, index) in formDetails.lTwoInstalledMeta"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">BRAND</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.lTwoInstalledMeta[index].brand"
                        :options="formDetails.lTwoInstalledMeta[index].dropdownOptions.brand"
                        class="multiselect single"
                        :placeholder="'Select a brand'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="viewForm"
                        @input="getComplexFormDropdownOptions('installed', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">MODEL</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.lTwoInstalledMeta[index].model"
                        :options="formDetails.lTwoInstalledMeta[index].dropdownOptions.model"
                        class="multiselect single"
                        :placeholder="'Select a model'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="!formDetails.lTwoInstalledMeta[index].brand || viewForm"
                        @input="resetRowValues('installed-compliant-quantity', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li
                      class="custom-input sm flex-row"
                      :class="[
                        (validationCheck && (compliantInstalled === 0 || lTwoConnectorsTotal > 0) ? 'required' : '') ||
                          (formDetails.lTwoInstalledMeta[index].quantity &&
                          formDetails.lTwoInstalledMeta[index].quantity < 0
                            ? 'required'
                            : ''),
                      ]"
                    >
                      <input
                        :class="[formDetails.lTwoInstalledMeta[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.lTwoInstalledMeta[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.lTwoInstalledMeta, index, 'L2AC', 'Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.lTwoInstalledMeta.length > 1"
                    @click="openModal('remove', formDetails.lTwoInstalledMeta, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
                <button
                  class="add-button"
                  @click="addRow(formDetails.lTwoInstalledMeta, 'L2AC', 'Standard')"
                  v-if="!viewForm"
                >
                  ADD BRAND/MODEL
                </button>
              </div>
              <div class="non-standard-charger">
                <h4 class="charger-title">Mopar Connectors and Non Compliant Connectors</h4>
                <div
                  class="input-fields non-standard flex-row"
                  v-for="(charger, index) in formDetails.lTwoInstalledOtherFields"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER BRAND</label></li>
                    <li class="custom-input lg flex-row" :class="[viewForm ? 'disabled' : '']">
                      <GInput
                        type="input"
                        v-model="formDetails.lTwoInstalledOtherFields[index].brand"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :disabled="viewForm"
                        @input="resetRowValues('installed-non-compliant-brand', index)"
                      ></GInput>
                      <span class="custom-input-buttons flex-row" v-if="!viewForm">
                        <span
                          class="edit-button"
                          @click="resetRowValues('installed-non-compliant-brand', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER MODEL</label></li>
                    <li
                      class="custom-input lg flex-row"
                      :class="[formDetails.lTwoInstalledOtherFields[index].brand ? '' : 'disabled']"
                      :disabled="viewForm"
                    >
                      <GInput
                        type="input"
                        v-model="formDetails.lTwoInstalledOtherFields[index].model"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :class="[formDetails.lTwoInstalledOtherFields[index].brand ? '' : 'disabled']"
                        :disabled="viewForm"
                        @input="resetRowValues('installed-non-compliant-model', index)"
                      ></GInput>
                      <span
                        v-if="formDetails.lTwoInstalledOtherFields[index].brand"
                        class="custom-input-buttons flex-row"
                        :disabled="viewForm"
                      >
                        <span
                          class="edit-button"
                          @click="resetRowValues('installed-non-compliant-model', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li class="custom-input sm flex-row">
                      <input
                        :class="[formDetails.lTwoInstalledOtherFields[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.lTwoInstalledOtherFields[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.lTwoInstalledOtherFields, index, 'L2AC', 'Non-Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.lTwoInstalledOtherFields.length > 1"
                    @click="openModal('remove', formDetails.lTwoInstalledOtherFields, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
                <button
                  class="non-standard-button"
                  @click="addRow(formDetails.lTwoInstalledOtherFields, 'L2AC', 'Non-Standard')"
                  v-if="!viewForm"
                >
                  ADD OTHER BRAND/MODEL
                </button>
              </div>
              <h4 class="equipment-type">ON ORDER/NOT YET INSTALLED CONNECTORS</h4>
              <div class="standard-charger">
                <h4 class="charger-title">Compliant Connectors</h4>
                <div
                  class="input-fields flex-row"
                  v-for="(charger, index) in formDetails.lTwoUninstalledMeta"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">BRAND</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.lTwoUninstalledMeta[index].brand"
                        :options="formDetails.lTwoUninstalledMeta[index].dropdownOptions.brand"
                        class="multiselect single"
                        :placeholder="'Select a brand'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="viewForm"
                        @input="getComplexFormDropdownOptions('uninstalled', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">MODEL</label></li>
                    <li>
                      <Multiselect
                        v-model="formDetails.lTwoUninstalledMeta[index].model"
                        :options="formDetails.lTwoUninstalledMeta[index].dropdownOptions.model"
                        class="multiselect single"
                        :placeholder="'Select a model'"
                        :showLabels="false"
                        :allow-empty="false"
                        :disabled="!formDetails.lTwoUninstalledMeta[index].brand || viewForm"
                        @input="resetRowValues('uninstalled-compliant-quantity', index)"
                      ></Multiselect>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li
                      class="custom-input sm flex-row"
                      :class="[
                        (validationCheck && (compliantOnOrder === 0 || lTwoConnectorsTotal > 0) ? 'required' : '') ||
                          (formDetails.lTwoUninstalledMeta[index].quantity &&
                          formDetails.lTwoUninstalledMeta[index].quantity < 0
                            ? 'required'
                            : ''),
                      ]"
                    >
                      <input
                        :class="[formDetails.lTwoUninstalledMeta[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.lTwoUninstalledMeta[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.lTwoUninstalledMeta, index, 'L2AC', 'Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.lTwoUninstalledMeta.length > 1"
                    @click="openModal('remove', formDetails.lTwoUninstalledMeta, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
                <button
                  class="add-button"
                  @click="addRow(formDetails.lTwoUninstalledMeta, 'L2AC', 'Standard')"
                  v-if="!viewForm"
                >
                  ADD BRAND/MODEL
                </button>
              </div>
              <div class="non-standard-charger">
                <h4 class="charger-title">Non-Compliant Connectors</h4>
                <div
                  class="input-fields non-standard flex-row"
                  v-for="(charger, index) in formDetails.lTwoUninstalledOtherFields"
                  :key="index"
                >
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER BRAND</label></li>
                    <li class="custom-input lg flex-row" :class="[viewForm ? 'disabled' : '']">
                      <GInput
                        type="input"
                        v-model="formDetails.lTwoUninstalledOtherFields[index].brand"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :disabled="viewForm"
                        @input="resetRowValues('uninstalled-non-compliant-brand', index)"
                      ></GInput>
                      <span class="custom-input-buttons flex-row" v-if="!viewForm">
                        <span
                          class="edit-button"
                          @click="resetRowValues('uninstalled-non-compliant-brand', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="multiselect">OTHER MODEL</label></li>
                    <li
                      class="custom-input lg flex-row"
                      :class="[formDetails.lTwoUninstalledOtherFields[index].brand ? '' : 'disabled']"
                      :disabled="viewForm"
                    >
                      <GInput
                        type="input"
                        v-model="formDetails.lTwoUninstalledOtherFields[index].model"
                        maxlength="150"
                        :showCount="true"
                        class="input-box"
                        :placeholder="'Enter input'"
                        :class="[formDetails.lTwoUninstalledOtherFields[index].brand ? '' : 'disabled']"
                        :disabled="viewForm"
                        @input="resetRowValues('uninstalled-non-compliant-model', index)"
                      ></GInput>
                      <span
                        v-if="formDetails.lTwoUninstalledOtherFields[index].brand"
                        class="custom-input-buttons flex-row"
                        :disabled="viewForm"
                      >
                        <span
                          class="edit-button"
                          @click="resetRowValues('uninstalled-non-compliant-model', index, 'clear')"
                          >{{ $t('clear') }}</span
                        >
                      </span>
                    </li>
                  </ul>
                  <ul>
                    <li class="input-label" v-if="index === 0"><label for="custom-input">CONNECTORS</label></li>
                    <li class="custom-input sm flex-row">
                      <input
                        :class="[formDetails.lTwoUninstalledOtherFields[index].model ? '' : 'disabled']"
                        required
                        v-model="formDetails.lTwoUninstalledOtherFields[index].quantity"
                        :placeholder="'Enter quantity'"
                        :disabled="viewForm"
                        type="number"
                        min="0"
                      />
                    </li>
                  </ul>
                  <div
                    class="reset flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    @click="openModal('reset', formDetails.lTwoUninstalledOtherFields, index, 'L2AC', 'Non-Standard')"
                    v-if="!viewForm"
                  >
                    <Reset />
                  </div>
                  <div
                    class="remove flex-column"
                    :class="[index === 0 ? 'first-row-element' : '']"
                    v-if="formDetails.lTwoUninstalledOtherFields.length > 1"
                    @click="openModal('remove', formDetails.lTwoUninstalledOtherFields, index)"
                    :disabled="viewForm"
                  >
                    <Remove />
                  </div>
                </div>
                <button
                  class="non-standard-button"
                  @click="addRow(formDetails.lTwoUninstalledOtherFields, 'L2AC', 'Non-Standard')"
                  v-if="!viewForm"
                >
                  ADD OTHER BRAND/MODEL
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="signature">
          <div class="title">Uploader</div>
          <div class="input-fields flex-row">
            <ul>
              <li class="input-label">Date:</li>
              <li class="custom-input disabled">
                <span class="date">{{ date | date }}</span>
              </li>
            </ul>
            <ul>
              <li><label for="custom-input">* Name:</label></li>
              <li
                class="custom-input flex-row"
                :class="[validationCheck && !formDetails.dealerSignature ? 'required' : '']"
              >
                <input
                  :class="[viewForm ? 'disabled' : '']"
                  required
                  v-model="formDetails.dealerSignature"
                  :placeholder="'Enter name'"
                />
                <span class="custom-input-buttons flex-row" v-if="!viewForm">
                  <span class="edit-button" @click="formDetails.dealerSignature = null">{{ $t('clear') }}</span>
                </span>
              </li>
            </ul>
          </div>
          <span class="note"
            >Note: After proof of charging equipment installation and activation has been uploaded, it will be reviewed
            by Stellantis. When the review is complete, the associated pillar dial will be updated the next business
            day.</span
          >
        </div>
        <div class="button-container flex-row">
          <button
            class="submit-button"
            :class="[submitValidation ? '' : 'disabled']"
            v-if="!viewForm"
            @click="validateEverything"
          >
            {{ $t('submit') }}
          </button>
          <button class="exit-button" v-if="!viewForm" @click="openModal('cancel')">{{ $t('exit') }}</button>
          <button class="exit-button" v-if="viewForm" @click="exit">{{ $t('exit') }}</button>
        </div>
      </div>
    </div>
    <Modal class="modal-screens" v-show="isModalOpen.remove">
      <template v-slot:body class="body">
        <div class="modal-content">
          <span class="modal-title">Remove Row?</span>
          <span class="modal-text">Are you sure you want to remove this row? This action cannot be undone.</span>
        </div>
        <div class="modal-button-container">
          <button class="submit" @click="setButtonAction('remove')">Remove</button>
          <button class="cancel-button" @click="setButtonAction('close', 'remove')">{{ $t('cancel') }}</button>
        </div>
      </template>
    </Modal>
    <Modal class="modal-screens" v-show="isModalOpen.reset">
      <template v-slot:body class="body">
        <div class="modal-content">
          <span class="modal-title">Clear Row?</span>
          <span class="modal-text">Are you sure you want to clear this row? This action cannot be undone.</span>
        </div>
        <div class="modal-button-container">
          <button class="submit" @click="setButtonAction('reset')">Clear</button>
          <button class="cancel-button" @click="setButtonAction('close', 'reset')">{{ $t('cancel') }}</button>
        </div>
      </template>
    </Modal>
    <Modal class="modal-screens" v-show="isModalOpen.submit">
      <template v-slot:body class="body">
        <div class="modal-content">
          <span class="modal-title">Continue to submit?</span>
          <span class="modal-text"
            >One of your active compliant is currently less than the required charger data. Are you sure you want to
            continue?</span
          >
          <span class="modal-text alert-text"
            >Click “Continue” if you have grandfathered connectors that you know will be counted towards meeting your
            required number of connectors.</span
          >
        </div>
        <div class="modal-button-container">
          <button class="submit" @click="setButtonAction('submit')">Continue</button>
          <button class="cancel-button" @click="setButtonAction('close', 'submit')">{{ $t('cancel') }}</button>
        </div>
      </template>
    </Modal>
    <Modal class="modal-screens" v-show="isModalOpen.cancel">
      <template v-slot:body class="body">
        <div class="modal-content">
          <span class="modal-title">Confirm Cancellation?</span>
          <span class="modal-text"
            >You are cancelling this request. This action cannot be undone. Are you sure you want to confirm your
            cancellation?</span
          >
        </div>
        <div class="modal-button-container">
          <button class="submit" @click="setButtonAction('cancel')">Confirm</button>
          <button class="cancel-button" @click="setButtonAction('close', 'cancel')">{{ $t('cancel') }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Upload from '@/components/Upload.vue';
import Multiselect from 'vue-multiselect';
import GInput from '@/components/GComponents/GInput.vue';
import Reset from '@/assets/new/icon_reset.svg';
import Remove from '@/assets/new/icon_delete_new.svg';
import Modal from '@/components/Modal.vue';
import { mapState } from 'vuex';

export default {
  name: 'LevelTwoForm',
  components: { Upload, Multiselect, GInput, Reset, Remove, Modal },
  props: {
    appealType: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      appeals: [],
      uploads: [],
      date: new Date(),
      showChargers: {
        lTwo: true,
        dcfc: true,
      },
      lTwoChargersResult: 0,
      dcfcChargersResult: 0,
      helperTextError: false,
      validationCheck: false,
      isModalOpen: {
        remove: false,
        reset: false,
        submit: false,
        cancel: false,
      },
      showModalButton: false,
      rowInfo: {
        action: null,
        row: null,
        index: null,
        chargerName: null,
        chargerType: null,
      },
      formDetails: {
        dealerSignature: null,
        vendor: null,
        // cpms: null,
        lTwoCompliant: null,
        lTwoOnOrderCompliant: null,
        lTwoOnOrderNonCompliant: null,
        lTwoNonCompliant: null,
        // dcfcCompliant: null,
        // dcfcNonCompliant: null,
        dcfcConnectCompliant: null,
        dcfcConnectNonCompliant: null,
        dcfcOnOrderCompliant: null,
        dcfcOnOrderNonCompliant: null,
        requiredLevelTwo: null,
        // requiredDcfc: null,
        requiredDcfcConnectors: null,
        lTwoInstalledMeta: [
          {
            brand: null,
            model: null,
            quantity: null,
            dropdownOptions: {
              brand: [],
              model: [],
            },
          },
        ],
        lTwoInstalledOtherFields: [
          {
            brand: null,
            model: null,
            quantity: null,
          },
        ],
        lTwoUninstalledMeta: [
          {
            brand: null,
            model: null,
            quantity: null,
            dropdownOptions: {
              brand: [],
              model: [],
            },
          },
        ],
        lTwoUninstalledOtherFields: [
          {
            brand: null,
            model: null,
            quantity: null,
          },
        ],
        dcfcInstalledMeta: [
          {
            brand: null,
            model: null,
            quantity: null,
            dropdownOptions: {
              brand: [],
              model: [],
            },
          },
        ],
        dcfcInstalledOtherFields: [
          {
            brand: null,
            model: null,
            quantity: null,
          },
        ],
        dcfcUninstalledMeta: [
          {
            brand: null,
            model: null,
            quantity: null,
            dropdownOptions: {
              brand: [],
              model: [],
            },
          },
        ],
        dcfcUninstalledotherFields: [
          {
            brand: null,
            model: null,
            quantity: null,
          },
        ],
      },
    };
  },
  methods: {
    openModal(action, row, index, chargerName, chargerType) {
      this.rowInfo.action = action;
      this.rowInfo.row = row;
      this.rowInfo.index = index;
      this.rowInfo.chargerName = chargerName;
      this.rowInfo.chargerType = chargerType;
      if (action === 'remove') {
        this.isModalOpen.remove = true;
      }
      if (action === 'reset') {
        this.isModalOpen.reset = true;
      }
      if (action === 'submit') {
        this.isModalOpen.submit = true;
      }
      if (action === 'cancel') {
        this.isModalOpen.cancel = true;
      }
    },
    setButtonAction(action, modalName) {
      if (action === 'remove') {
        this.removeRow(this.rowInfo.row, this.rowInfo.index);
        this.isModalOpen.remove = false;
      }
      if (action === 'reset') {
        this.resetRow(this.rowInfo.row, this.rowInfo.index, this.rowInfo.chargerName, this.rowInfo.chargerType);
        this.isModalOpen.reset = false;
      }
      if (action === 'submit') {
        this.isModalOpen.submit = false;
        this.saveComplexForm();
      }
      if (action === 'cancel') {
        this.isModalOpen.cancel = false;
        const tempComplexForm = {
          dealerSignature: null,
          vendor: null,
          // cpms: null,
          lTwoCompliant: null,
          lTwoOnOrderCompliant: null,
          lTwoOnOrderNonCompliant: null,
          lTwoNonCompliant: null,
          // dcfcCompliant: null,
          // dcfcNonCompliant: null,
          dcfcConnectCompliant: null,
          dcfcConnectNonCompliant: null,
          dcfcOnOrderCompliant: null,
          dcfcOnOrderNonCompliant: null,
          requiredLevelTwo: null,
          // requiredDcfc: null,
          requiredDcfcConnectors: null,
          lTwoInstalledMeta: [
            {
              brand: null,
              model: null,
              quantity: null,
              dropdownOptions: {
                brand: [],
                model: [],
              },
            },
          ],
          lTwoInstalledOtherFields: [
            {
              brand: null,
              model: null,
              quantity: null,
            },
          ],
          lTwoUninstalledMeta: [
            {
              brand: null,
              model: null,
              quantity: null,
              dropdownOptions: {
                brand: [],
                model: [],
              },
            },
          ],
          lTwoUninstalledOtherFields: [
            {
              brand: null,
              model: null,
              quantity: null,
            },
          ],
          dcfcInstalledMeta: [
            {
              brand: null,
              model: null,
              quantity: null,
              dropdownOptions: {
                brand: [],
                model: [],
              },
            },
          ],
          dcfcInstalledOtherFields: [
            {
              brand: null,
              model: null,
              quantity: null,
            },
          ],
          dcfcUninstalledMeta: [
            {
              brand: null,
              model: null,
              quantity: null,
              dropdownOptions: {
                brand: [],
                model: [],
              },
            },
          ],
          dcfcUninstalledotherFields: [
            {
              brand: null,
              model: null,
              quantity: null,
            },
          ],
        };
        Object.assign(this.formDetails, tempComplexForm);
        this.exit();
      }
      if (action === 'close') {
        if (modalName === 'remove') {
          this.isModalOpen.remove = false;
        }
        if (modalName === 'reset') {
          this.isModalOpen.reset = false;
        }
        if (modalName === 'submit') {
          this.isModalOpen.submit = false;
        }
        if (modalName === 'cancel') {
          this.isModalOpen.cancel = false;
        }
      }
      const tempObj = {
        action: null,
        row: null,
        index: null,
        chargerName: null,
        chargerType: null,
      };
      Object.assign(this.rowInfo, tempObj);
    },
    addRow(row, chargerName, chargerType) {
      let tempDropdownOptions = null;
      if (chargerType === 'Standard') {
        if (chargerName === 'L2AC') {
          tempDropdownOptions = {
            brand: [...this.formDetails.lTwoInstalledMeta[0].dropdownOptions.brand],
            model: [],
          };
        } else {
          tempDropdownOptions = {
            brand: [...this.formDetails.dcfcChargerMeta[0].dropdownOptions.brand],
            model: [],
          };
        }
        row.push({
          brand: null,
          model: null,
          quantity: null,
          dropdownOptions: tempDropdownOptions,
        });
      } else {
        row.push({
          brand: null,
          model: null,
          quantity: null,
        });
      }
    },
    removeRow(row, index) {
      row.splice(index, 1);
    },
    resetRow(row, index, chargerName, chargerType) {
      let tempDropdownOptions = null;
      if (chargerType === 'Standard') {
        if (chargerName === 'L2AC') {
          tempDropdownOptions = {
            brand: [...this.formDetails.lTwoInstalledMeta[0].dropdownOptions.brand],
            model: [],
          };
        } else {
          tempDropdownOptions = {
            brand: [...this.formDetails.dcfcChargerMeta[0].dropdownOptions.brand],
            model: [],
          };
        }
        const tempObj = {
          brand: null,
          model: null,
          quantity: null,
          dropdownOptions: tempDropdownOptions,
        };
        Object.assign(row[index], tempObj);
      } else {
        const tempObj = {
          brand: null,
          model: null,
          quantity: null,
        };
        Object.assign(row[index], tempObj);
      }
    },
    getComplexFormSupplementalData() {
      const loader = this.$loading.show();

      const { domain, entity } = this;

      let formId = '';
      if (this.appealType === 'submit') {
        formId = 'new';
      } else {
        const id = this.selectedForm[0].formId;
        formId = id;
      }

      this.$store
        .dispatch('getComplexFormSupplementalData', { formId, domain, entity })
        .then((res) => {
          this.setSupplementalData(res);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setSupplementalData(res) {
      if (this.appealType === 'submit') {
        // this.formDetails.requiredDcfc = res.requiredDcfc;
        // this.formDetails.requiredDcfcConnectors = res.requiredDcfcConnectors;
        this.formDetails.requiredLevelTwo = res.requiredLevelTwo;
      } else {
        Object.assign(this.formDetails, res);
        this.formDetails.dealerSignature = this.mostRecentStatus.dealerSignature;
      }
    },
    getComplexFormDropdownOptions(connectorType, dropdownIndex) {
      const loader = this.$loading.show();

      // Set charger type
      const chargerType = 'L2AC';

      // Set index
      let index = 0;
      if (dropdownIndex) {
        index = dropdownIndex;
      }

      // Set brand
      let brand = '';
      let tempBrand = '';
      if (connectorType === 'installed' && this.formDetails.lTwoInstalledMeta[index].brand) {
        tempBrand = this.formDetails.lTwoInstalledMeta[index].brand;
      } else if (connectorType === 'uninstalled' && this.formDetails.lTwoUninstalledMeta[index].brand) {
        tempBrand = this.formDetails.lTwoUninstalledMeta[index].brand;
      }
      brand = tempBrand;

      // Reset model dropdown and quantity values
      if (connectorType === 'installed') {
        this.formDetails.lTwoInstalledMeta[index].model = null;
        this.formDetails.lTwoInstalledMeta[index].quantity = null;
      } else {
        this.formDetails.lTwoUninstalledMeta[index].model = null;
        this.formDetails.lTwoUninstalledMeta[index].quantity = null;
      }

      this.$store
        .dispatch('getComplexFormDropdownOptions', { chargerType, brand })
        .then((res) => {
          this.setDropdownOptions(res.results, index, connectorType, brand);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    resetRowValues(charger, index, action) {
      if (charger === 'installed-compliant-quantity') {
        this.formDetails.lTwoInstalledMeta[index].quantity = null;
      }
      if (charger === 'installed-non-compliant-brand') {
        this.formDetails.lTwoInstalledOtherFields[index].model = null;
        this.formDetails.lTwoInstalledOtherFields[index].quantity = null;
        if (action === 'clear') {
          this.formDetails.lTwoInstalledOtherFields[index].brand = null;
        }
      }
      if (charger === 'installed-non-compliant-model') {
        this.formDetails.lTwoInstalledOtherFields[index].quantity = null;
        if (action === 'clear') {
          this.formDetails.lTwoInstalledOtherFields[index].model = null;
        }
      }
      if (charger === 'uninstalled-compliant-quantity') {
        this.formDetails.lTwoUninstalledMeta[index].quantity = null;
      }
      if (charger === 'uninstalled-non-compliant-brand') {
        this.formDetails.lTwoUninstalledOtherFields[index].model = null;
        this.formDetails.lTwoUninstalledOtherFields[index].quantity = null;
        if (action === 'clear') {
          this.formDetails.lTwoUninstalledOtherFields[index].brand = null;
        }
      }
      if (charger === 'uninstalled-non-compliant-model') {
        this.formDetails.lTwoUninstalledOtherFields[index].quantity = null;
        if (action === 'clear') {
          this.formDetails.lTwoUninstalledOtherFields[index].model = null;
        }
      }
      // if (charger === 'DCFC') {
      //   this.formDetails.dcfcChargerMeta[index].quantity = null;
      // }
      // if (charger === 'DCOtherBrand') {
      //   this.formDetails.dcfcOtherFields[index].model = null;
      //   this.formDetails.dcfcOtherFields[index].quantity = null;
      //   if (action === 'clear') {
      //     this.formDetails.dcfcOtherFields[index].brand = null;
      //   }
      // }
      // if (charger === 'DCOtherModel') {
      //   this.formDetails.dcfcOtherFields[index].quantity = null;
      //   if (action === 'clear') {
      //     this.formDetails.dcfcOtherFields[index].model = null;
      //   }
      // }
    },
    setDropdownOptions(res, index, connectorType, brand) {
      if (brand) {
        const modelArray = [];
        res.forEach((obj) => {
          if (!obj.model) {
            obj.model = 'Not Available';
          }
          modelArray.push(obj.model);
        });
        if (connectorType === 'installed') {
          this.formDetails.lTwoInstalledMeta[index].dropdownOptions.model = modelArray;
        } else {
          this.formDetails.lTwoUninstalledMeta[index].dropdownOptions.model = modelArray;
        }
      } else {
        const brandArray = [];
        res.forEach((obj) => {
          brandArray.push(obj.brand);
        });
        if (connectorType === 'installed') {
          this.formDetails.lTwoInstalledMeta[0].dropdownOptions.brand = brandArray;
        } else if (connectorType === 'uninstalled') {
          this.formDetails.lTwoUninstalledMeta[0].dropdownOptions.brand = brandArray;
        } else {
          this.formDetails.lTwoInstalledMeta[0].dropdownOptions.brand = brandArray;
          this.formDetails.lTwoUninstalledMeta[0].dropdownOptions.brand = brandArray;
        }
      }
    },
    saveComplexForm() {
      const loader = this.$loading.show();

      const items = [];

      const { lTwoConnectorsTotal, dcfcConnectorsTotal, domain, entity, uploads } = this;

      this.appeals.forEach((appeal) => {
        items.push(appeal);
      });

      const params = {
        domain,
        entity,
        items,
        uploads,
        status: 'submit',
        type: this.config.formType,
        layout: this.config.layout,
        result: 'Submitted',
        configId: this.config.id,
        lTwoConnectorsTotal,
        dcfcConnectorsTotal,
      };

      Object.assign(params, this.formDetails);

      this.submitForm(params);
      loader.hide();
    },
    submitForm(params) {
      const loader = this.$loading.show();

      this.$store
        .dispatch('submitForm', params)
        .then(() => {
          this.$notify({
            group: 'primary',
            type: 'success',
            text: 'Charging Form Successfully Submitted!',
          });
          this.validationCheck = false;
          this.exit();
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    exit() {
      this.$router.push({
        name: 'Dealer-Forms',
      });
    },
    getUrl(res) {
      const upload = {
        adjustedFilename: res.res.data.fileInfo.adjustedFilename,
        originalFilename: res.res.data.fileInfo.originalFilename,
        label: res.appeal.dialTitle,
        dialId: res.appeal.dialId,
      };
      this.uploads.push(upload);
    },
    getAppeals() {
      if (this.appealType === 'view') {
        this.appeals = JSON.parse(JSON.stringify(this.selectedForm));
        this.isAcknowledged = true;
      } else {
        this.appeals = [
          {
            dialColor: 'N',
            dialId: '0',
            dialResultText: '',
            dialTitle:
              'Up to 2 Non Compliant Mopar Connectors will count towards the requirement through the approval process. You must upload photos of your installed and active Level 2 charging equipment. If you have fewer than required number of active Level 2 chargers for your dealership, you may receive conditional approval of your level 2 charging equipment by uploading photos of at least two (2) active level 2 charging connectors, and additionally also uploading documentation that the balance of required number of level 2 connectors have been ordered or are in your possession.',
          },
        ];
      }
    },
    removeUpload(selectedFile) {
      this.uploads.forEach((file, index) => {
        if (file.originalFilename === selectedFile.file) {
          this.uploads.splice(index, 1);
        }
      });
    },
    validateEverything() {
      this.validationCheck = true;
      if (this.uploadsValidation && this.lTwoConnectorsTotal <= 0) {
        this.saveComplexForm();
      } else if (this.uploadsValidation && this.lTwoConnectorsTotal > 0) {
        this.openModal('submit');
      } else {
        this.$notify({
          group: 'primary',
          type: 'error',
          text: 'Please double check the highlighted fields and try again.',
        });
      }
    },
    calculateLTwoChargersTotal() {
      const tempLTwoCompliant = this.formDetails.lTwoCompliant;
      const tempLTwoOnOrderCompliant = this.formDetails.lTwoOnOrderCompliant;
      // const tempLTwoInstalledMeta = this.formDetails.lTwoInstalledMeta;
      // const tempLTwoInstalledOtherFields = this.formDetails.lTwoInstalledOtherFields;
      // const quantityArray = [];
      // let quantityTotal = 0;

      // tempLTwoInstalledMeta.forEach((obj) => {
      //   quantityArray.push(obj.quantity);
      // });

      // tempLTwoInstalledOtherFields.forEach((obj) => {
      //   quantityArray.push(obj.quantity);
      // });

      // quantityArray.forEach((value) => {
      //   if (value) {
      //     quantityTotal += parseInt(value, 10);
      //   }
      // });

      // if (!tempLTwoCompliant) {
      //   tempLTwoCompliant = 0;
      // }

      this.lTwoChargersResult =
        parseInt(this.formDetails.requiredLevelTwo, 10) -
        (parseInt(tempLTwoCompliant, 10) + parseInt(tempLTwoOnOrderCompliant, 10));
      if (!this.lTwoChargersResult) {
        this.lTwoChargersResult = 0;
      }
    },
    // calculateDcfcChargersTotal() {
    //   let tempDcfcCompliant = this.formDetails.dcfcCompliant;
    //   const tempDcfcChargerMeta = this.formDetails.dcfcChargerMeta;
    //   const tempDcfcOtherFields = this.formDetails.dcfcOtherFields;
    //   const quantityArray = [];
    //   let quantityTotal = 0;

    //   tempDcfcChargerMeta.forEach((obj) => {
    //     quantityArray.push(obj.quantity);
    //   });

    //   tempDcfcOtherFields.forEach((obj) => {
    //     quantityArray.push(obj.quantity);
    //   });

    //   quantityArray.forEach((value) => {
    //     if (value) {
    //       quantityTotal += parseInt(value, 10);
    //     }
    //   });

    //   if (!tempDcfcCompliant) {
    //     tempDcfcCompliant = 0;
    //   }

    //   this.dcfcChargersResult = parseInt(tempDcfcCompliant, 10) - parseInt(quantityTotal, 10);
    //   if (!this.dcfcChargersResult) {
    //     this.dcfcChargersResult = 0;
    //   }
    // },
    calculateTotalConnectors(connectorType) {
      if (connectorType === this.formDetails.lTwoInstalledMeta) {
        let total = 0;
        connectorType.forEach((connector) => {
          if (connector.brand && connector.model && connector.quantity) {
            total += parseInt(connector.quantity, 10);
          }
        });
        this.formDetails.lTwoCompliant = total;
        return this.formDetails.lTwoCompliant;
      }
      if (connectorType === this.formDetails.lTwoUninstalledMeta) {
        let total = 0;
        connectorType.forEach((connector) => {
          if (connector.brand && connector.model && connector.quantity) {
            total += parseInt(connector.quantity, 10);
          }
        });
        this.formDetails.lTwoOnOrderCompliant = total;
        return this.formDetails.lTwoOnOrderCompliant;
      }
      if (connectorType === this.formDetails.lTwoInstalledOtherFields) {
        let total = 0;
        connectorType.forEach((connector) => {
          if (connector.brand && connector.model && connector.quantity) {
            total += parseInt(connector.quantity, 10);
          }
        });
        this.formDetails.lTwoNonCompliant = total;
        return this.formDetails.lTwoNonCompliant;
      }
      let total = 0;
      connectorType.forEach((connector) => {
        if (connector.brand && connector.model && connector.quantity) {
          total += parseInt(connector.quantity, 10);
        }
      });
      this.formDetails.lTwoOnOrderNonCompliant = total;
      return this.formDetails.lTwoOnOrderNonCompliant;
    },
  },
  computed: {
    ...mapState('global', ['programStyle', 'programName']),
    ...mapState(['selectedForm', 'otherAppealInfo']),
    entity() {
      return this.$route.params.entity;
    },
    domain() {
      return this.$route.params.domain;
    },
    rows() {
      if (this.archiveResults && this.value) {
        return this.archiveResults[this.value.value];
      }
      return null;
    },
    uploadValidationCheck() {
      let valid = true;

      this.appeals.forEach((appeal) => {
        if (valid) {
          valid = this.uploads.some((upload) => upload.dialId === appeal.dialId);
        }
      });
      return valid;
    },
    mostRecentStatus() {
      if (this.otherAppealInfo) {
        return this.otherAppealInfo.statuses[0];
      }
      return null;
    },
    lTwoConnectorsTotal() {
      this.calculateLTwoChargersTotal();
      return this.lTwoChargersResult;
    },
    compliantInstalled() {
      return this.calculateTotalConnectors(this.formDetails.lTwoInstalledMeta);
    },
    compliantOnOrder() {
      return this.calculateTotalConnectors(this.formDetails.lTwoUninstalledMeta);
    },
    nonCompliantInstalled() {
      return this.calculateTotalConnectors(this.formDetails.lTwoInstalledOtherFields);
    },
    nonCompliantOnOrder() {
      return this.calculateTotalConnectors(this.formDetails.lTwoUninstalledOtherFields);
    },
    dcfcConnectorsTotal() {
      // this.calculateDcfcChargersTotal();
      return this.dcfcChargersResult;
    },
    viewForm() {
      return this.appealType === 'view';
    },
    requiredBoxValidation() {
      if (this.formDetails.lTwoCompliant < this.formDetails.requiredLevelTwo) {
        return false;
      }
      // if (this.formDetails.dcfcCompliant < this.formDetails.requiredDcfc) {
      //   return false;
      // }
      // if (this.formDetails.dcfcConnectCompliant < this.formDetails.requiredDcfcConnectors) {
      //   return false;
      // }
      return true;
    },
    uploadsValidation() {
      if (this.uploads.length === 0) {
        return false;
      }
      return true;
    },
    requiredLevelTwoValidation() {
      if (this.formDetails.lTwoCompliant && this.formDetails.lTwoCompliant < this.formDetails.requiredLevelTwo) {
        return false;
      }
      return true;
    },
    requiredDcfcValidation() {
      if (this.formDetails.dcfcCompliant && this.formDetails.dcfcCompliant < this.formDetails.requiredDcfc) {
        return false;
      }
      return true;
    },
    requiredDcfcConnectorsValidation() {
      if (
        this.formDetails.dcfcConnectCompliant &&
        this.formDetails.dcfcConnectCompliant < this.formDetails.requiredDcfcConnectors
      ) {
        return false;
      }
      return true;
    },
    submitValidation() {
      if (this.uploads.length > 0 && this.formDetails.vendor && this.formDetails.dealerSignature) {
        return true;
      }
      return false;
    },
  },
  watch: {},
  created() {
    this.getAppeals();
    if (this.appealType === 'submit') {
      this.getComplexFormDropdownOptions('L2AC');
      // this.getComplexFormDropdownOptions('DCFC');
      this.getComplexFormSupplementalData();
    } else {
      this.getComplexFormSupplementalData();
    }
  },
  beforeDestroy() {
    this.$emit('exit');
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: #000000;
  text-align: left;
  .link {
    color: #243882;
  }
  padding: 30px 30px 45px;
  input:focus {
    outline: none;
  }
}
.title {
  color: #243882;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
  margin-bottom: 30px;
}
.title-small {
  font-size: 14px;
}
.item-container {
  margin: 30px 0 35px;
  .dial-info {
    display: flex;
    margin-bottom: 30px;
  }
}
.right-container {
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  text-transform: uppercase;
  input {
    height: 100px;
    width: initial;
    background: $input-background;
    border: none;
    margin-bottom: 20px;
  }
  .item {
    display: flex;
    flex-direction: column;
  }
}
.upload-container {
  font-size: 14px;
  .title {
    font-size: 14px;
    color: $primary-black;
    font-weight: bold;
    line-height: 20px;
    text-transform: uppercase;
    margin: 0px;
  }
  .support-docs {
    display: flex;
    align-items: center;
  }
}
.left-container {
  min-width: 80px;
  align-items: center;
  margin-right: 20px;
}
.subtitle {
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: normal;
  text-transform: none;
}
.description {
  margin: 10px 0;
}
.bottom-container {
  font-size: 14px;
  line-height: 20px;
  span {
    margin-bottom: 20px;
  }
  span:last-child {
    margin-bottom: 0px;
  }
}
.button-container {
  margin-top: 45px;
  align-items: center;
  justify-content: flex-start;
  button {
    margin-right: 15px;
  }
  button:hover {
    text-decoration: underline;
  }
  .exit-button {
    background-color: $primary-white;
    border: 1px solid $primary;
    color: $primary;
  }
}
.helper-text {
  font-size: 14px;
  color: $primary-black;
  &_success {
    color: #008716 !important;
    span {
      color: #008716 !important;
      font-size: 14px !important;
    }
  }
  &_error {
    color: $error !important;
    h4 {
      color: $error !important;
      font-size: 14px !important;
      line-height: 20px !important;
      margin: 15px 0px 0px !important;
      text-transform: none;
    }
  }
  &_notify {
    color: $primary-black;
    opacity: 0.5 !important;
    font-size: 14px !important;
  }
}
.required {
  border: 1px solid red !important;
}
.row-title {
  font-size: 15px;
  line-height: 21px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 35px 0px 15px 0px;
  display: block;
}
.requirements {
  margin: 15px 0px 45px;
  span {
    font-size: 14px;
    line-height: 20px;
    color: $primary-black;
    margin: 10px 0px 0px;
  }
  span:first-child {
    margin: 0px 0px 0px;
  }
}
ul {
  list-style-type: none;
  margin: 0px;
  padding: 0px 30px 0px 0px;
  .input-label {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 25px;
    &.required-level-two {
      margin-top: 55px;
    }
    &.unidentified-connectors {
      margin-top: 55px;
    }
    &.connector-type {
      margin-top: 10px;
      text-decoration: underline;
      text-align: left;
    }
    &.vendor-name {
      margin-top: 0px;
    }
  }
  .sm {
    width: 200px !important;
  }
  .md {
    width: 239px !important;
  }
  .lg {
    width: 373px !important;
  }
  .xl {
    width: 550px !important;
  }
  .multiselect {
    margin-top: 15px;
  }
  li[disabled] {
    background: $input-readonly;
  }
  span[disabled] {
    pointer-events: none;
    opacity: 0;
  }
}
button {
  &.add-button {
    margin-top: 20px;
  }
  &.non-standard-button {
    margin-top: 20px;
  }
  &.disabled {
    pointer-events: none;
  }
}
button:hover {
  text-decoration: underline;
}
.row-1 {
  ul:last-child {
    padding-right: 0px;
  }
}
.custom-input {
  margin-top: 15px;
  border: 1px solid $border;
  width: 289px;
  height: 47px;
  justify-content: space-between;
  input {
    border: none;
    padding: 0px 15px;
    height: 100%;
  }
  input.disabled {
    pointer-events: none;
    background: #d1d1d1;
    color: $input-readonly-text;
  }
  .custom-input-buttons {
    padding: 0px 15px;
    align-items: center;
    .edit-button {
      font-size: 14px;
      color: #243882;
      cursor: pointer;
    }
    .disabled {
      opacity: 0.7;
      cursor: default;
      pointer-events: none;
    }
  }
}
.row-2 {
  margin: 45px 0px 0px;
}
.row-title-container {
  margin: 0px -30px 0px -30px;
  padding: 16px 30px 17px 30px;
  background-color: $primary;
  justify-content: space-between;
  align-items: center;
}
.row-title-container:hover {
  cursor: pointer;
}
.collapsible-row-title {
  font-size: 18px;
  line-height: 24px;
  font-weight: bold;
  text-transform: uppercase;
  color: $primary-white;
  margin: 0px;
}
.equipment-type,
.charger-title {
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  color: $primary-white;
  background-color: #008716;
  margin: 0px -30px;
  padding: 10px 30px;
  &.dcfc-chargers {
    margin-top: 25px;
  }
  &.dcfc-connectors {
    margin-top: 45px;
  }
}
.charger-title {
  background-color: #56687b;
  text-transform: none;
  margin-top: 5px;
}
.non-standard-charger {
  margin: 45px 0px;
  .custom-input {
    margin-bottom: 20px;
  }
}
.row-3 {
  margin: 45px 0px 0px;
  .requirements {
    &.connectors {
      margin-bottom: 15px !important;
    }
  }
}
.signature {
  ul {
    .input-label {
      font-size: 15px;
      line-height: 21px;
      font-weight: normal;
      text-transform: none;
      margin-top: 0px !important;
    }
    .input-label-required {
      font-weight: bold;
      text-transform: uppercase;
    }
    .date {
      background: $input-background;
      display: block;
      margin: 15px 0px 0px 15px;
    }
  }
  .note {
    margin-top: 20px;
    display: block;
  }
}
.reset,
.remove {
  justify-content: center;
  margin-top: 10px;
  svg {
    height: 22px;
    width: 31px;
    cursor: pointer;
  }
}
.remove {
  margin-left: 30px;
  svg {
    width: 20px;
  }
}
.first-row-element {
  margin-top: 60px;
}
.carrot {
  height: 12px !important;
  cursor: pointer;
  width: 24px;
  transform: rotate(180deg);
  path {
    fill: $primary-white;
  }
}
.carrot-flipped {
  height: 12px !important;
  cursor: pointer;
  transform: rotate(360deg);
  width: 24px;
  path {
    fill: $primary-white;
  }
}
div[disabled] {
  pointer-events: none;
  opacity: 0;
}
.modal-body {
  display: flex;
  flex-direction: column;
  .close {
    display: flex;
    justify-content: flex-end;
    svg {
      height: 30px;
      width: 30px;
      cursor: pointer;
    }
  }
  .modal-content {
    width: 100%;
    text-align: center;
  }
  .modal-title {
    font-size: 20px;
    line-height: 26px;
    color: $primary;
    text-transform: uppercase;
    font-weight: bold;
    display: block;
    margin-bottom: 20px;
  }
  .modal-text {
    font-size: 14px;
    line-height: 20px;
    color: $primary-black;
    display: block;
    &.alert-text {
      color: $error;
      padding-top: 15px;
    }
  }
  .modal-button-container {
    display: flex;
    margin-top: 35px;
    justify-content: center;
    .submit {
      margin-right: 20px;
    }
    .cancel-button {
      background-color: #ffffff;
      border: 1px solid #243882;
      color: #243882;
    }
  }
}
</style>
